// extracted by mini-css-extract-plugin
export var page = "pages-module--page--paNvM";
export var body = "pages-module--body--Q+gQu";